import { ChannelName } from './websocket.types';

// No trailing slash: the server anchors its routes, so /report/ misses.
export const CHANNELS: Readonly<Record<ChannelName, string>> = {
  ReportChannel: 'report',
  CallsChannel: 'calls',
  WebchatAgentChannel: 'webchat_agent',
};

// VITE_BASE_WS_URL is a BASE, not a complete endpoint — one path per channel now. Unset
// falls back to same-origin, so local dev goes through the vite proxy instead of past it.
const defaultBase = (loc: { protocol: string; host: string }): string => {
  const scheme = loc.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${scheme}//${loc.host}/api/websocket`;
};

export const channelUrl = (
  channel: ChannelName,
  loc: { protocol: string; host: string } = window.location
): string => {
  const base = import.meta.env.VITE_BASE_WS_URL || defaultBase(loc);
  return `${base.replace(/\/+$/, '')}/${CHANNELS[channel]}`;
};

export type { ChannelName };
